<template>
	<ListItem
		is-recipient
		:custom-text="text"
	/>
</template>
<script>
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";
import {mapState} from "vuex";

export default {
	components: {
		ListItem
	},

	computed: {
		...mapState('auth', ['application']),
		text ()
		{
			return '<b>Danke für dein Fazit!</b><br/>Sobald die Firma entschieden hat, wirst du kontaktiert!';
		}
	}
}
</script>
